/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ItemTileCarousel_item = {
    readonly " $fragmentRefs": FragmentRefs<"ItemTileBase_item" | "ProductCarousel_item">;
    readonly " $refType": "ItemTileCarousel_item";
};
export type ItemTileCarousel_item$data = ItemTileCarousel_item;
export type ItemTileCarousel_item$key = {
    readonly " $data"?: ItemTileCarousel_item$data;
    readonly " $fragmentRefs": FragmentRefs<"ItemTileCarousel_item">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "isTrade"
    },
    {
      "defaultValue": "searchAndBrowse",
      "kind": "LocalArgument",
      "name": "pageDisplayEnum"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "showSeller"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ItemTileCarousel_item",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isTrade",
          "variableName": "isTrade"
        },
        {
          "kind": "Variable",
          "name": "pageDisplayEnum",
          "variableName": "pageDisplayEnum"
        },
        {
          "kind": "Variable",
          "name": "showSeller",
          "variableName": "showSeller"
        }
      ],
      "kind": "FragmentSpread",
      "name": "ItemTileBase_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProductCarousel_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};
(node as any).hash = 'a0521ef89021ab407f38f823afcf9de7';
export default node;
